export class User {
    token: string;
    version: string;
}
